export class DispersionesFiltrosRequest {
    idUsuario: number;
    idBeneficiarioTipo: number;
    idCatDepartamento: number;
    idCatCentroCostos: number;
    idCatCentroTrabajo: number;
    fechaDesde: string;
    fechaHasta: string;
}